/**
 * GA4 event tracking helpers.
 * Fires only if gtag is loaded (index.html loads the GA snippet).
 */

const HAS_GTAG = () => typeof window !== "undefined" && typeof window.gtag === "function";

export function trackEvent(name, params = {}) {
    if (!HAS_GTAG()) return;
    try {
        window.gtag("event", name, params);
    } catch (e) {
        // silent
    }
}

// Convenience shortcuts for the events that matter for Real-Check
export const trackPageView = (path) => trackEvent("page_view", { page_path: path });

export const trackFactCheck = (mode, verdict, confidence) =>
    trackEvent("fact_check_completed", {
        check_mode: mode,        // claim | scam
        verdict,                  // true | false | scam | etc.
        confidence,
    });

export const trackVoiceCheck = (verdict) => trackEvent("voice_check_completed", { verdict });
export const trackPhotoCheck = (verdict) => trackEvent("photo_check_completed", { verdict });

export const trackSignup = (method) => trackEvent("sign_up", { method });   // email | google
export const trackLogin = (method) => trackEvent("login", { method });

export const trackDonationStart = (amount) => trackEvent("begin_checkout", {
    currency: "USD", value: Number(amount), items: [{ item_name: "Hands of Hope donation" }],
});
export const trackDonationSuccess = (amount, sessionId) => trackEvent("purchase", {
    transaction_id: sessionId,
    currency: "USD",
    value: Number(amount),
    items: [{ item_name: "Hands of Hope donation" }],
});
export const trackSubscriptionStart = (plan) => trackEvent("begin_checkout", {
    currency: "USD",
    value: plan === "yearly" ? 39 : 4.99,
    items: [{ item_name: `Real-Check Pro ${plan}` }],
});

export const trackNewsletterSignup = (source) => trackEvent("newsletter_signup", { source });
export const trackThemeChange = (themeId) => trackEvent("theme_changed", { theme: themeId });
export const trackShare = (method) => trackEvent("share", { method });
